// @flow

import type {MarkdocRenderTag} from 'markdoc/types';

export const isMarkdocAstTag = (tag: MarkdocRenderTag | string) => {
  if (typeof tag === 'object') {
    return tag.astType === 'Tag';
  }
  return false;
};
